import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormFieldDisplayedOrRequired from './FormFieldDisplayedOrRequired';

class FormFieldRow extends Component {
    render() {
        const { code, isDisabled, name, showcreateProfile, showguestDetails, showquickSignUp } = this.props;

        return (
            <tr>
                <td>{name}</td>
                <td>
                    <FormFieldDisplayedOrRequired
                        fieldCode={code}
                        formType="quickSignUp"
                        isDisabled={isDisabled}
                        show={showquickSignUp}
                    />
                </td>
                <td>
                    <FormFieldDisplayedOrRequired
                        fieldCode={code}
                        formType="createProfile"
                        isDisabled={isDisabled}
                        show={showcreateProfile}
                    />
                </td>
                <td>
                    <FormFieldDisplayedOrRequired
                        fieldCode={code}
                        formType="guestDetails"
                        isDisabled={isDisabled}
                        show={showguestDetails}
                    />
                </td>
            </tr>
        );
    }
}

FormFieldRow.defaultProps = {
    showquickSignUp: false,
    showcreateProfile: false,
    showguestDetails: false
};

FormFieldRow.propTypes = {
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    showquickSignUp: PropTypes.bool,
    showcreateProfile: PropTypes.bool,
    showguestDetails: PropTypes.bool
};

export default FormFieldRow;



// WEBPACK FOOTER //
// ./src/components/widgets/TableFormFields/FormFieldRow.js